import { isDesktop } from "../../services/service-utils.js";
import RichText from "../rich-text/rich-text.js";
import Accordion from "../accordion/accordion.js";
import { richTextModule } from "./richTextModule.js";
import { infoBoxModule } from "./infoBoxModule.js";
import { accordionModule } from "./accordionModule.js";
import { guideTitle } from "./guideTitle.js";
import { receiptQuiz } from "./receiptQuiz.js";
import { imageModule } from "./imageModule.js";
import { quoteModule } from "./quoteModule.js";
import { button } from "./button.js";
import { checkForCompleated } from "./checkForCompleated.js";
import { receiptQuizFunction } from "./receiptQuizFunction.js";
import { guideStepCompleation } from "./guideStepCompleation.js";
import { setStepAsCompleated } from "./SetStepAsCompleated.js";
import { insertInfoTextAfterCompleation } from "./insertInfoTextAfterCompleation.js";

export default class GuidePage {
  constructor(element) {
    this.el = element;
    this.GuideID = this.el.dataset.guideid;
    this.guideContainer = this.el.querySelector(".guide-container");
    this.pagetitle = this.el.dataset.pagetitle;
    this.stepJson = {};
    this.stepList = ``;
    this.precentCompleated = 0;
    this.userId = this.el.dataset.uid;

    this.fetchStartPage = this.fetchStartPage.bind(this);
    this.generateStartPage = this.generateStartPage.bind(this);
    this.fetchChildren = this.fetchChildren.bind(this);
    this.generateStepList = this.generateStepList.bind(this);
    this.generateGuidePage = this.generateGuidePage.bind(this);
    this.generateGuidePageContent = this.generateGuidePageContent.bind(this);
    this.initContentElements = this.initContentElements.bind(this);
    this.generateStepButtons = this.generateStepButtons.bind(this);
    this.stepCompleated = this.stepCompleated.bind(this);

    this.init();
  }
  init() {
    if (this.GuideID) {
      this.fetchChildren(this.GuideID, "startpage");
    }
  }

  fetchStartPage(guideid, pageType) {
    var myHeaders = new Headers();
    myHeaders.append("Api-Key", "sesamsesam");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`/umbraco/delivery/api/v1/content/item/${guideid}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        switch (pageType) {
          case "startpage":
            this.generateStartPage(result);
            break;
          default:
            //find the parent of this.el and add the class section-margin
            if (!isDesktop()) {
              this.el.parentElement.classList.add("section-margin");
            }
            this.generateGuidePage(result);
            break;
        }
      })
      .catch((error) => console.log("error", error));
  }

  generateStartPage(json) {
    var html = `
      <div class="grid grid-cols-12 gap-5 bg-blue-10 shadow-hover">
        <div class="col-span-12 md:col-span-6 p-5 md:p-20">
          <p class="text-tiny mb-4">${this.pagetitle}</p>
          <h1 class="text-blue text-headline4 md:text-headline2-lg font-black lg:mb-10">${json.properties.title}</h1>
          ${json.properties.description.markup}
        </div>
        <div class="col-span-12 md:col-span-6 ${json.properties.background ? json.properties.background.label : ""} p-5 md:p-20">
          ${this.generateStepList(this.stepJson)}
        </div>      
      </div>
      `;
    this.guideContainer.insertAdjacentHTML("beforeend", html);
    let startpageSteps = this.guideContainer.querySelectorAll(".guide-container button");
    if (startpageSteps) {
      startpageSteps.forEach((item) => {
        item.addEventListener("click", (e) => {
          this.fetchStartPage(item.dataset.stepkey, "guidepage");
        });
      });
    }
  }

  fetchChildren(guideid, step) {
    var myHeaders = new Headers();
    myHeaders.append("Api-Key", "sesamsesam");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`/api/guides/${guideid}/steps-for-user/${this.userId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        this.precentCompleated = result.percentageDone;
        this.stepJson = result.steps;
        switch (step) {
          case "startpage":
            this.fetchStartPage(this.GuideID, "startpage");
            break;
          default:
            this.fetchStartPage(this.GuideID, "startpage");
            break;
        }
      })
      .catch((error) => console.log("error", error));
  }

  generateStepList(json) {
    const steps = json
      .map((item, index) => {
        return `<button data-stepkey="${item.contentKey}" data-isreceipt="${item.isReceipt}" class="flex w-full mb-2 lg:p-6 justify-start items-center bg-blue border-blue border-2 text-white py-[10px] px-6 gap-4 rounded-[107px] transition duration-150 ease-in-out hover:bg-blue-black hover:border-blue-black"><span class="guide-counter font-bold ${item.isCompleted ? `active text-blue border-pink` : `border-white`}"><span>${item.stepNumber}</span></span><p>${item.titleName}</p><span></span></button>`;
      })
      .join("");
    return steps;
  }

  generateStepButtons(json, currentStep) {
    const steps = json
      .map((item, index) => {
        return `<button ${currentStep === item.contentKey ? `data-currentstep` : ``}  data-stepkey="${item.contentKey}" data-isreceipt="${item.isReceipt}" class="${currentStep === item.contentKey ? `bg-blue-10` : ``}  flex w-full mb-2 lg:p-6 justify-start items-center text-blue py-[10px] px-3 gap-4 rounded-tl-[107px] rounded-tr-[107px] md:rounded-tr-none md:rounded-bl-[107px] rounded transition duration-150 ease-in-out hover:bg-blue-10"><span class="guide-counter font-bold border-blue ${item.isCompleted ? `bg-blue text-white` : ``}"><span>${item.stepNumber}</span></span></button>`;
      })
      .join("");
    return steps;
  }

  generateGuidePage(json, isReceipt) {
    let pageTitle = this.pagetitle;
    let stepTitle = json.properties.title;
    let duration = json.properties.duration;
    let grid = json.properties.content.items;
    let gridLength = grid[0].areas.length;
    const currentStep = this.stepJson.filter((item) => item.contentKey === json.id)[0];
    const guidePage = `
    <div class="absolute w-full overflow-clip flex md:block -top-16 md:top-0 left-0 md:w-15 md:bg-white z-10 pt-3" data-stepbuttons>
      ${this.generateStepButtons(this.stepJson, json.id)}
    </div>
    <div class="relative">
      <div class="h-3 bg-blue-20 md:rounded-t-xl overflow-x-hidden relative">
        <span class="bg-blue-black h-3 block rounded-tr-xl rounded-br-xl md:rounded-none" data-progressbar style="width:${this.precentCompleated}%"><span>
      </div>
      <div data-progresspercent class="absolute top-3 md:-top-5 ${this.precentCompleated > 10 && this.precentCompleated < 90 ? `-translate-x-1/2` : ``} ${this.precentCompleated >= 90 ? `-translate-x-full` : ``}" style="left:${this.precentCompleated}%">${this.precentCompleated}%</div>
    </div>
    <div class="outer shadow-hove bg-blue-10 p-5 md:p-20">
    <div class="grid grid-cols-12 gap-5">
      <div class="col-span-12">
        <p class="text-tiny ${gridLength === 1 ? `mb-5` : ``}">${pageTitle}</p>
        ${
          //inster guideTitle if gridLength === 1
          gridLength === 1 && !isReceipt ? guideTitle(pageTitle, stepTitle, duration) : ``
        }
        ${
          //if receipt, show receipt text and button
          isReceipt
            ? `
           <p class="text-blue text-headline2-lg font-black lg:mb-4 pt-5">${json.properties.receiptTitle}</p>
           <div class="col-span-8 justify-start mb-4">${json.properties.receiptDescription.markup}</div>
            <div class="col-span-12 flex justify-start items-center gap-5 py-8 flex-wrap">
              ${button(json.properties.receiptButton[0], "actionbutton", true)}
            </div>
           `
            : ``
        }
      </div>
      ${
        //if not receipt, show grid
        !isReceipt
          ? `
      
        <div class="col-span-12 grid grid-cols-12 gap-x-5" data-contentcontainer>
        ${
          //loop through outer rows
          grid
            .map((item, firstindex) => {
              //loop through columns
              return item.areas
                .map((area, index) => {
                  return `
              <div class="col-span-12 md:col-span-${area.columnSpan}">
                ${
                  //if grid.areas[0].length is 2 and this is the first item in the area.index  then call guideTitle with json.properties.title and json.properties.duration
                  grid[0].areas.length != 1 && index === 0 && firstindex === 0 ? guideTitle(this.pagetitle, json.properties.title, json.properties.duration) : ``
                }
                ${
                  //get the blocklist components
                  area.items
                    .map((contentItem) => {
                      return this.generateGuidePageContent(contentItem);
                    })
                    .join("")
                }
                ${
                  //if guide step first column in last row and columnSpan is 6 add link and/or checkmark
                  !currentStep.isReceipt && firstindex + 1 === grid.length && area.columnSpan === 6 && index === 0 && isDesktop() ? guideStepCompleation(json, currentStep) : ``
                }                
              </div>`;
                })
                .join("");
            })
            .join("")
        }
        </div>

        ${
          //if guidestep and last row is 12 then add button and checkmark
          (!currentStep.isReceipt && grid[grid.length - 1].areas.length === 1 && isDesktop()) || (!isDesktop() && !currentStep.isReceipt)
            ? `            
              <div class="col-span-12 flex justify-start items-steat gap-5 py-8 flex-wrap">
                ${guideStepCompleation(json, currentStep)}
              </div>            
            `
            : ``
        }
      </div>
      ${currentStep.isReceipt ? `<div class="md:gap-5 pt-5 overflow-x-hidden sm:pb-20 sm:pl-20 sm:pr-0">${receiptQuiz(json.properties.quiz.items, this.stepJson)}</div>` : ``}
      `
          : ``
      }
      ${isReceipt ? `</div>` : ``}
      </div>
      <div class="flex justify-center items-center gap-5 py-8">
        <button data-stepkey="${currentStep.prevStep}" class="w-10 h-10 rounded-full bg-blue-20 flex justify-center text-white items-center hover:bg-blue-black ${currentStep.prevStep === null ? `invisible` : ``}"><svg class="w-2 h-4"><use xlink:href="/spritemap.svg#sprite-back"></use></svg></button>
        </span></button>
        <button data-stepkey="${currentStep.nextStep}" class="w-10 h-10 rounded-full bg-blue-20 flex justify-center text-white items-center hover:bg-blue-black ${currentStep.nextStep === null ? `invisible` : ``}"><svg class="w-2 h-4"><use xlink:href="/spritemap.svg#sprite-forward"></use></svg></button>                
      </div>
    `;
    //fade out and remove content from this.guideContainer
    this.guideContainer.classList.add("fade-out");
    setTimeout(() => {
      this.guideContainer.innerHTML = "";
      this.guideContainer.insertAdjacentHTML("beforeend", guidePage);
      this.initContentElements();
      //find height of data-stepbuttons and set .outer min-height to this height
      let stepButtonsContainer = this.guideContainer.querySelector("[data-stepbuttons]");
      let outer = this.guideContainer.querySelector(".outer");
      if (stepButtonsContainer && outer) {
        let stepButtonsHeight = stepButtonsContainer.offsetHeight;
        outer.style.minHeight = `${stepButtonsHeight}px`;
      }
      //find quiz and add eventlisteners
      let quiz = this.guideContainer.querySelector(".guide-quiz-outer");
      if (quiz) {
        receiptQuizFunction(quiz);
        //find last quiz-slide
        let lastQuizSlide = quiz.querySelector(".quiz-slide:last-of-type");
        //add eventlistener to last quiz-slide radio buttons
        let lastQuizSlideRadioButtons = lastQuizSlide.querySelectorAll("input[type='radio']");
        if (lastQuizSlideRadioButtons && !checkForCompleated(this.stepJson)) {
          lastQuizSlideRadioButtons.forEach((item) => {
            item.addEventListener("change", (e) => {
              if (item.checked && item.value === "true") {
                this.generateGuidePage(json, true);
              }
            });
          });
        }
      }
      //scroll page to top
      window.scrollTo(0, 0);
      //fade in content
      this.guideContainer.classList.remove("fade-out");
      //add eventlisteners to step buttons
      let stepButtons = this.guideContainer.querySelectorAll("[data-stepkey]");
      if (stepButtons) {
        stepButtons.forEach((item) => {
          item.addEventListener("click", (e) => {
            if (item.dataset.isreceipt === "true") {
              this.fetchStartPage(item.dataset.stepkey, "receiptpage");
            } else {
              this.fetchStartPage(item.dataset.stepkey, "guidepage");
            }
          });
        });
      }
      let actionLink = this.guideContainer.querySelector("[data-type='actionbutton']");
      let stepCheck = this.guideContainer.querySelector("[data-type='stepcheckbox']");

      if (actionLink) {
        actionLink.addEventListener("click", (e) => {
          if (json.properties.requiredActionButton) {
            stepCheck.classList.remove("hidden");
          } else {
            this.stepCompleated(currentStep.contentKey, this.userId, this.GuideID);
            setStepAsCompleated(this.stepJson, json, this.guideContainer);
          }

          if (json.properties.hideActionLinkAfterStep) {
            actionLink.classList.remove("md:flex");
            actionLink.classList.add("hidden");
          }
          if (json.properties.infoTextAfterStep) {
            insertInfoTextAfterCompleation(actionLink, json.properties.infoTextAfterStep, "afterend");
          }
        });
      }

      if (stepCheck) {
        //let stepCheckbox be checkbox in stepCheck
        let stepCheckbox = stepCheck.querySelector("input");
        stepCheckbox.addEventListener("change", (e) => {
          if (stepCheckbox.checked) {
            this.stepCompleated(currentStep.contentKey, this.userId, this.GuideID);
            //set stepCheckBox to disabled
            stepCheckbox.disabled = true;
            setStepAsCompleated(this.stepJson, json, this.guideContainer);
          }
        });
        if (currentStep.isCompleted && json.properties.hideActionLinkAfterStep) {
          insertInfoTextAfterCompleation(stepCheck, json.properties.infoTextAfterStep, "beforebegin");
        }
      }
    }, 500);
  }

  stepCompleated(stepKey, userId, guideId) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      IsCompleted: true,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`/api/guides/${guideId}/steps/${stepKey}/update-step-for-user/${userId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        this.precentCompleated = JSON.parse(result).percentageDone;
        //find the item with data-progressbar and set width to this.precentCompleated
        let progressBar = this.guideContainer.querySelector("[data-progressbar]");
        progressBar.style.width = `${this.precentCompleated}%`;
        //find the item with data-progresspercent and set innerHTML to this.precentCompleated + % and left position to this.precentCompleated
        let progressPercent = this.guideContainer.querySelector("[data-progresspercent]");
        progressPercent.innerHTML = `${this.precentCompleated}%`;
        progressPercent.style.left = `${this.precentCompleated}%`;
        //find this item in this.stepJson
        let step = this.stepJson.filter((item) => item.contentKey === stepKey)[0];
        //call fetchChildren with nextStep.contentKey if nextStep.isReceipt === false
        if (!step.isReceipt) {
          this.fetchStartPage(step.nextStep, "guidepage");
        }
      })
      .catch((error) => console.log("error", error));
  }

  generateGuidePageContent(json) {
    //create a function which returns the correct markup based on the content type
    let contentType = json.content.contentType;
    let content = "";
    switch (contentType) {
      case "richTextModule":
        content = richTextModule(json.content);
        break;
      case "infoBoxModule":
        content = infoBoxModule(json.content);
        break;
      case "accordionModule":
        content = accordionModule(json.content);
        break;
      case "imageModule":
        content = imageModule(json.content);
        break;
      case "quoteModule":
        content = quoteModule(json.content);
        break;
      default:
        return "";
    }
    return content;
  }

  initContentElements() {
    let contentElements = this.guideContainer.querySelectorAll("[data-component]");
    if (contentElements) {
      contentElements.forEach((item) => {
        switch (item.dataset.component) {
          case "rich-text":
            new RichText(item);
            break;
          case "accordion":
            new Accordion(item);
          default:
            break;
        }
      });
    }
  }
}
